import { pluralize, localizeNumber } from 'shared/utils';

export function pointsToNextStatus(currentPoints, nextStatus) {
  const { point_value, name } = nextStatus;
  const remainder = point_value - currentPoints;
  return `${localizeNumber(remainder)} ${pluralize(
    'point',
    remainder
  )} to ${name} Status`;
}

export function statusBackgroundStyles(tier, angle) {
  const colors = [
    tier.primary_color,
    tier.secondary_color,
    tier.tertiary_color
  ].filter(c => !!c);

  return colors.length === 1
    ? { backgroundColor: colors[0] }
    : { background: `linear-gradient(${angle}, ${colors.join(', ')})` };
}
